import copy from 'fast-copy';

const userDataHandler = {
    namespaced: true,
    state: {
        users: {
            list: [],
            usersGroups: []
        },
        user: null,
        selectedUser: null,
        userGroup: null,
        userGroups: {
            list: []
        },
    },
    mutations: {
        updateUsers(state, newList) {
            state.users.list = newList;
        },
        updateUserGroups(state, newList) {
            state.userGroups.list = newList;
        },
        setUserGroups(state, newList) {
            state.users.usersGroups = newList;
        },
        setSelectedUser(state, user) {
            state.selectedUser = user;
        },
        setUserGroup(state, userGroup) {
            state.userGroup = userGroup;
        },
        setUserData(state, newItem) {
            state.user = newItem;
        }        
    },
    actions: {   
        getUsers(context) {
            this._vm.$traveller_http.get('/traveller/restui/user/getUsers')
            .then(response => {
                context.commit('updateUsers', response.data);
            });
        },
        updateUser(context, newUser) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/user/saveUser', newUser)
                    .then(response => {
                        if (response.status == 200)
                            context.dispatch('getUsers');
                        resolve(response);
                    }).catch(error => {
                        reject(error);
                    })
            })
        }, 
        deleteUser( context, userId ) {
            return new Promise((resolve , reject ) => {
                const config = {
                    params: { userId: userId },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
                this._vm.$traveller_http.post('/traveller/restui/user/deleteUser' ,
                    null , config ).then(
                        response => {
                            if( response.status == 200 )
                                context.dispatch('getUsers');
                            resolve(response)
                        } ).catch( error => {
                            reject(error)
                        } )
            })
        },   
        getUsersGroups(context, userId) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.get('/traveller/restui/user/getUsersGroups' , { params: { "userId": userId }})
                   .then( response => {                
                       context.commit('setUserGroups', response.data );
                       resolve(response)
                }).catch( error => {
                    reject(error)
                } )
            })   
        },
        saveUserGroups( context, usersGroups, user ) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/user/saveUserGroups' ,usersGroups)
                .then ( response => {
                    if( response.status == 200 )
                        context.commit('setUserData', user);
                    resolve(response);
                }).catch( error => {
                    reject(error);
                } )
            })
        },
        saveUserPrivileges( context, userPrivileges, user ) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/user/saveUserPrivileges' ,userPrivileges)
                .then ( response => {
                    if( response.status == 200 )
                        context.commit('setUserData', user);
                    resolve(response);
                }).catch( error => {
                    reject(error);
                } )
            })
        },
        saveUserParameters( context, userParameters, user ) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/user/saveUserParameters' ,userParameters)
                .then ( response => {
                    if( response.status == 200 )
                        context.commit('setUserData', user);
                    resolve(response);
                }).catch( error => {
                    reject(error);
                })
            })
        },
        getUserGroup(context, userGroupId) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.get('/traveller/restui/user/getUserGroup' , { params: { "userGroupId": userGroupId }})
                   .then( response => {                
                       context.commit('setUserGroup', response.data );
                       resolve(response)
                }).catch( error => {
                    reject(error)
                })
            })   
        },
        deleteUsersGroups( context, userId ) {
            return new Promise((resolve , reject ) => {
                const config = {
                    params: { userId: userId },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            this._vm.$traveller_http.post('/traveller/restui/user/deleteUsersGroups' ,
                null , config ).then(
                    response => {
                        if( response.status == 200 )
                            context.dispatch('getUserGroups');
                        resolve(response)
                    } ).catch( error => {
                        reject(error)
                    }) 
            })
        },      
        deleteUsersPrivileges( context, userId ) {
            return new Promise((resolve , reject ) => {
                const config = {
                    params: { userId: userId },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            this._vm.$traveller_http.post('/traveller/restui/user/deleteUsersPrivileges' ,
                null , config ).then(
                    response => {
                        resolve(response)
                    } ).catch( error => {
                        reject(error)
                    }) 
            })
        },      
        deleteUserGroup( context, userGroupId ) {
            return new Promise((resolve , reject ) => {
                const config = {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            this._vm.$traveller_http.post('/traveller/restui/user/deleteUserGroup' ,
                userGroupId , config ).then(
                    response => {
                        if( response.status == 200 )
                            context.dispatch('getUserGroups');
                        resolve(response)
                    } ).catch( error => {
                        reject(error)
                    }) 
            })
        },      
        updateUserGroup(context , newUserGroup ) {
            return new Promise((resolve , reject) => {
                let userGroup = copy( newUserGroup )
                // userCnt is used to show user count for each group
                // This won't be saved on server side and needs to be removed
                delete userGroup.userCnt
                this._vm.$traveller_http.post('/traveller/restui/user/saveUserGroup' , userGroup )
                .then ( response => {
                    if( response.status == 200 )
                        context.dispatch('getUserGroups');
                    resolve(response);
                }).catch( error => {
                    reject(error);
                } )
            })
        }, 
        saveUserGroupPrivileges( context, userGroupPrivileges, userGroup ) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/user/saveUserGroupPrivileges' ,userGroupPrivileges)
                .then ( response => {
                    if( response.status == 200 )
                        context.commit('setUserGroup', userGroup);
                    resolve(response);
                }).catch( error => {
                    reject(error);
                } )
            })
        },
        saveUserGroupParameters( context, userGroupParameters, userGroup ) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/user/saveUserGroupParameters' ,userGroupParameters)
                .then ( response => {
                    if( response.status == 200 )
                        context.commit('setUserGroup', userGroup);
                    resolve(response);
                }).catch( error => {
                    reject(error);
                } )
            })
        },
        getUserGroups(context) {
            this._vm.$traveller_http.get('/traveller/restui/user/getUserGroups')
            .then(response => {
                context.commit('updateUserGroups', response.data);
            });
        },
        savePassword( context, passwd ) {
            return new Promise((resolve , reject ) => {
                const config = {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
                this._vm.$traveller_http.post('/traveller/restui/user/savePassword', passwd, config)
                .then(response => {
                    resolve(response);
                } ).catch( error => {
                            reject(error);
                } )
            })
        }
    }    
        
}

export default userDataHandler;